module.exports = __webpack_public_path__ + "img/阻力带硬拉.1f971235.png";